import { useState, useEffect, useMemo } from "react";

export const useForm = (initialForm = {}, formValidations = {}) => {
  const [formState, setFormState] = useState(initialForm);
  const [formValidation, setFormValidation] = useState({});
  const [fileError, setFileError] = useState(null); // Nuevo estado para el error

  useEffect(() => {
    createValidators();
  }, [formState]);

  useEffect(() => {
    setFormState(initialForm);
  }, [initialForm]);

  useEffect(() => {
    createValidators();
  }, [formValidations]);

  const isFormValid = useMemo(() => {
    for (const formValue of Object.keys(formValidation)) {
      if (formValidation[formValue] !== null) return false;
    }
    return true;
  }, [formValidation]);

  const onInputChange = ({ target }) => {
    const { name, value } = target;
    setFormState({
      ...formState,
      [name]: value,
    });
  };

  const onCheckBoxChange = ({ target }) => {
    const { name, checked } = target;
    setFormState({
      ...formState,
      [name]: checked,
    });
  };

  const onFileInputChange = ({ target }) => {
    const { name, files } = target;
    const currentFiles = formState[name] ? Array.from(formState[name]) : [];
    // Detecta archivos duplicados
    const duplicated = Array.from(files).find((file) =>
      currentFiles.some((f) => f.name === file.name)
    );
    if (duplicated) {
      setFileError(`El archivo "${duplicated.name}" ya fue agregado.`);
      return;
    }
    setFileError(""); // Limpia el error si no hay duplicados
    const newFiles = Array.from(files).filter(
      (file) => !currentFiles.some((f) => f.name === file.name)
    );
    setFormState({
      ...formState,
      [name]: [...currentFiles, ...newFiles],
    });
  };

  const onFileRemove = (name, indexToRemove) => {
    setFormState((prevState) => {
      const currentFiles = prevState[name] ? Array.from(prevState[name]) : [];
      const updatedFiles = currentFiles.filter(
        (_, idx) => idx !== indexToRemove
      );
      return {
        ...prevState,
        [name]: updatedFiles,
      };
    });
  };

  const onResetForm = () => {
    setFormState(initialForm);
    setFileError(null);
  };

  const createValidators = () => {
    const formCheckedValues = {};

    for (const formField of Object.keys(formValidations)) {
      const validations = formValidations[formField];
      const fieldValue = formState[formField];

      const valueToValidate =
        fieldValue instanceof FileList ? Array.from(fieldValue) : fieldValue;

      let errorMessage = null;

      for (let i = 0; i < validations.length; i += 2) {
        const fn = validations[i];
        const message = validations[i + 1];

        if (!fn(valueToValidate)) {
          errorMessage = message;
          break;
        }
      }

      formCheckedValues[`${formField}Valid`] = errorMessage;
    }

    setFormValidation(formCheckedValues);
  };

  return {
    formState,
    onInputChange,
    onCheckBoxChange,
    onResetForm,
    onFileInputChange,
    onFileRemove,
    formValidation,
    isFormValid,
    fileError,
  };
};
